export default {
  // General
  app_name: 'mvplan',
  calculate: 'Calcular descompresión',
  save: 'Guardar',
  cancel: 'Cancelar',
  add: 'Añadir',
  edit: 'Editar',
  delete: 'Eliminar',
  reset: 'Restablecer',
  confirm_reset: 'Restablecer todos los ajustes?',
  confirm_delete: 'Eliminar este elemento?',

  // Navigation
  nav_plan: 'Plan',
  nav_gases: 'Gases',
  nav_profile: 'Perfil',
  nav_settings: 'Ajustes',
  nav_day: 'Jornada',

  // Jornada de buceo
  day_title: 'Jornada de buceo',
  day_empty: 'Todavía no hay ninguna inmersión en esta jornada.',
  day_empty_hint: 'Añada la inmersión de la pantalla Plan para empezar una serie.',
  day_add_current: 'Añadir la inmersión actual',
  day_add_needs_segments: 'La pantalla Plan no contiene ningún segmento: nada que añadir.',
  day_ask_surface_interval: 'Intervalo de superficie antes de esta inmersión, en minutos:',
  day_invalid_surface_interval: 'Introduzca un intervalo de superficie igual o superior a 0 min.',
  day_surface_interval: 'Intervalo de superficie',
  day_dive_label_placeholder: 'Nombre de la inmersión (opcional)',
  day_calculate: 'Calcular la jornada',
  day_clear: 'Vaciar la jornada',
  day_confirm_clear: '¿Eliminar todas las inmersiones de esta jornada?',
  day_remove_dive: 'Eliminar esta inmersión',
  day_confirm_remove: 'Las inmersiones siguientes están encadenadas a esta y habrá que recalcularlas.',
  day_dive_not_computed: 'Aún sin calcular',
  day_dive_stale: 'Calculada antes de una modificación: este plan ya no describe la serie.',
  day_dive_refused: 'Inmersión rechazada, revise las inmersiones anteriores de la serie.',
  day_dives_refused: '{count} inmersión(es) no se han podido planificar. Las siguientes están encadenadas a una inmersión que no existe.',
  day_summary: 'Total de la jornada',
  day_dives_count: 'Inmersiones',
  day_summary_partial: 'Los totales cubren {computed} inmersión(es) calculada(s) de {total}.',
  day_editing_dive: 'Está editando la inmersión {number} de la jornada.',
  day_save_into_day: 'Guardar en la jornada',
  day_detach: 'Desvincular',
  day_dive_number: 'Inmersión {number} de {total}',
  day_first_dive: 'Primera inmersión de la jornada',
  day_nothing_to_export: 'Ninguna inmersión de esta jornada se ha calculado: nada que exportar.',
  day_export_failed: 'No se ha podido generar el documento. Inténtelo de nuevo y consulte la consola del navegador.',

  // Saved days
  saved_days_title: 'Jornadas guardadas',
  saved_days_save: 'Guardar la jornada',
  saved_days_saved: 'Jornada guardada',
  saved_days_save_failed: 'No se ha podido guardar esta jornada: no contiene ninguna inmersión, o el almacenamiento está lleno.',
  saved_days_name_placeholder: 'p. ej. Port-Cros, sábado',
  saved_days_empty: 'Ninguna jornada guardada.',
  saved_days_empty_hint: 'Componga una jornada de buceo y guárdela para encontrarla aquí.',
  saved_days_confirm_delete: '¿Eliminar esta jornada?',
  saved_days_import_error: 'Este archivo no es una jornada de buceo exportada por mvplan.',

  // Settings
  settings_algorithm: 'Algoritmo',
  settings_gf: 'Factores de gradiente',
  settings_gf_low: 'GF Bajo',
  settings_gf_high: 'GF Alto',
  settings_rates: 'Velocidades y Paradas',
  settings_descent: 'Descenso',
  settings_ascent: 'Ascenso',
  settings_deco_ascent: 'Entre paradas',
  settings_last_stop_ascent: 'Ascenso final',
  settings_last_stop: 'Última parada',
  settings_safety_stop: 'Parada de seguridad si no hay deco (min, 0 = ninguna)',
  settings_rmv: 'RMV',
  settings_rmv_bottom: 'Fondo',
  settings_rmv_deco: 'Deco / Bailout',
  settings_ccr: 'Modo CCR',
  settings_setpoint_mode: 'Modo Setpoint',
  settings_setpoint_fixed: 'Fijo',
  settings_setpoint_dynamic: 'Dinámico',
  settings_ppo2: 'Límites ppO2',
  settings_ppo2_working: 'Trabajo',
  settings_ppo2_deco: 'Deco',
  settings_display: 'Pantalla',
  settings_units: 'Unidades',
  settings_units_metric: 'Métricas (m, bar)',
  settings_units_imperial: 'Imperiales (ft, psi)',
  settings_theme: 'Tema',
  settings_theme_dark: 'Oscuro',
  settings_theme_light: 'Claro',
  settings_language: 'Idioma',
  settings_divers: 'Buceadores',
  settings_divers_hint: 'Nombres impresos en el PDF (separados por comas)',
  settings_dive_site: 'Sitio de buceo',
  settings_dive_site_placeholder: 'ej. Blue Hole, Dahab',
  settings_bailout: 'Bailout',
  settings_bail_delay: 'Retraso bailout (min)',
  settings_bail_delay_hint: 'Tiempo en el fondo antes de ascender en bailout',
  settings_rmv_stress: 'RMV Estrés',
  settings_stress_until: 'Estrés hasta',
  settings_stress_first_stop: 'Primera parada',
  settings_stress_gas_switch: 'Cambio de gas',
  settings_stress_surface: 'Superficie',
  settings_time_and_gas: 'Tiempos y cambios de gas',
  settings_descent_included: 'Descenso incluido',
  settings_descent_included_hint: 'El tiempo de descenso está incluido en la duración del segmento',
  settings_gas_switch_duration: 'Duración del cambio de gas',
  settings_gas_switch_at_stop: 'Cambiar gas solo en parada deco',
  settings_gas_switch_at_stop_hint: 'Si está desactivado, el cambio se realiza en cuanto la MOD lo permite (más óptimo)',
  settings_gf_presets: 'Presets GF',
  settings_gf_presets_hint: 'Acceso rápido en la vista del Plan',
  settings_gf_add_preset: 'Añadir preset',
  settings_gf_preset_name: 'Nombre',
  settings_gf_custom: 'Personalizado',
  settings_environment: 'Entorno',
  settings_gas_temp: 'Temp. gas',
  settings_water_type: 'Tipo de agua',
  settings_water_salt: 'Agua salada',
  settings_water_fresh: 'Agua dulce',
  settings_water_brackish: 'Agua salobre',
  settings_water_red_sea: 'Mar Rojo',
  settings_water_custom: 'Densidad personalizada',
  settings_water_density: 'Densidad del agua',
  settings_water_density_hint: 'La densidad del agua cambia la presión realmente soportada a una profundidad dada y, por tanto, la duración de las paradas. Valores de referencia: 10000 en agua dulce, 10150 en agua salobre, 10300 en el mar, 10400 en el mar Rojo (10300 equivale a 1.03 kg/l). Valores aceptados: de {min} a {max}.',
  settings_altitude: 'Altitud',
  settings_environment_hint: 'Temp. gas = temperatura pulmonar para el cálculo de densidad (~35°C). La altitud y el tipo de agua también modifican el cálculo de descompresión.',
  settings_alerts: 'Alertas de seguridad',
  settings_alerts_hint: 'Desactivar alertas para buceadores experimentados',
  settings_alerts_narcosis: 'Alertas de narcosis (END)',
  settings_alerts_density: 'Alertas de densidad (CO2)',
  settings_alerts_show_density: 'Mostrar siempre la densidad del gas',
  settings_ccr_flush: 'Barridos del circuito (CCR)',
  settings_ccr_flush_hint: 'Añade un editor de barridos a la pantalla de plan para las inmersiones con recirculador.',
  settings_ccr_flush_duration: 'Duración de barrido por defecto (min)',
  settings_ccr_o2_flush: 'Final de la inmersión con 100% de oxígeno',
  settings_ccr_o2_flush_hint: 'A la profundidad indicada, el circuito pasa a oxígeno puro y sigue así hasta la superficie.',
  settings_ccr_o2_flush_depth: 'Profundidad (m)',
  settings_ccr_o2_flush_time: 'Duración del barrido (min)',
  settings_ccr_o2_flush_invalid: 'Profundidad o duración inutilizable.',
  settings_alerts_icd: 'Alertas ICD (oído interno)',
  settings_pdf: 'Exportación PDF',
  settings_pdf_include_profile: 'Incluir perfil de inmersión',
  settings_pdf_include_profile_hint: 'Desactivar para caber en una sola página A4',
  settings_school_mode: 'Modo escuela',
  settings_school_mode_hint: 'Comparar presets GF en el gráfico de perfil',
  settings_chart_scale: 'Escala del gráfico',
  settings_school_presets: 'Presets a comparar',
  profile_school_compare: 'Comparación GF',
  profile_school_tts: 'TTS',
  profile_school_stops: 'Paradas',

  // Gases
  gases_title: 'Mezclas de gas',
  gases_bailout: 'Gases de rescate',
  gases_diluents: 'Diluyentes',
  gases_name: 'Nombre',
  gases_mod: 'MOD',
  gases_end: 'END',
  gases_ppo2_max: 'ppO2 max',
  gases_use_bailout: 'Usar como bailout',
  gases_tank_config: 'Configuración de botella',
  gases_volume: 'Volumen (L)',
  gases_pressure: 'Presión (bar)',
  gases_capacity: 'Capacidad',

  // Plan
  plan_segments: 'Segmentos de buceo',
  plan_depth: 'Profundidad',
  plan_time: 'Tiempo',
  plan_runtime: 'Runtime',
  plan_gas: 'Gas',
  plan_setpoint: 'SP',
  plan_no_segments: 'Sin segmentos. Añade uno para empezar.',
  plan_config: 'Configuración',
  plan_ccr: 'Plan CCR',
  plan_bailout: 'Bailout (Peor caso)',
  plan_deco: 'Plan de descompresión',
  plan_no_deco: 'No requiere descompresión',
  plan_stops_summary: 'Resumen de paradas',
  duration_hours_minutes: '{h} h {m}',
  duration_hours: '{h} h',
  duration_minutes: '{m} min',
  plan_desat_sea_level: 'Si permanece al nivel del mar, estará totalmente desaturado {time} después de salir del agua.',
  plan_desat_altitude: 'Si permanece a {altitude} m de altitud, estará totalmente desaturado {time} después de salir del agua.',
  plan_desat_over: 'La desaturación completa requiere más de {time} después de salir del agua.',
  plan_no_fly: 'Vuelo (DAN)',
  plan_no_fly_minimum: '> {time}',
  plan_no_fly_dan_rule: 'Espera antes de volar, recomendaciones del consenso DAN: un intervalo en superficie de al menos {noStop} para una inmersión única sin descompresión; un intervalo en superficie de al menos {multiDay} para inmersiones repetitivas durante varios días; sustancialmente más de {longer} tras una inmersión con descompresión obligatoria, o con mezclas heliox y trimix. No es un cálculo de desaturación.',
  plan_no_fly_dan_case_no_stop: 'Esta inmersión corresponde al primer caso: una inmersión única sin paradas.',
  plan_no_fly_dan_case_repetitive: 'Esta inmersión corresponde al segundo caso: buceo repetitivo.',
  plan_no_fly_dan_case_deco: 'Esta inmersión corresponde al tercer caso: descompresión obligatoria. La espera mostrada es un mínimo a superar, no un valor recomendado.',
  plan_no_fly_dan_case_helium: 'Esta inmersión corresponde al tercer caso: mezcla con helio. La espera mostrada es un mínimo a superar, no un valor recomendado.',
  plan_no_fly_dan_source: 'Fuente: DAN, Guidelines for Flying After Diving, consenso del Flying After Recreational Diving Workshop (2002). Estos ensayos se realizaron en cámara seca con voluntarios en reposo: pueden ser necesarias esperas más largas para buceadores inmersos y en esfuerzo.',
  plan_tts: 'TTS',
  plan_cns: 'CNS',
  plan_otu: 'OTU',
  plan_cns_series: 'CNS (día)',
  plan_otu_series: 'OTU (día)',
  plan_gas_requirements: 'Necesidades de gas bailout',
  plan_gas_consumption: 'Consumo de gas',
  plan_liters: 'Litros',
  plan_type: 'Tipo',
  plan_ppo2: 'ppO2',
  plan_density: 'Densidad',
  plan_tissue: 'Tejido',
  plan_flush: 'Barridos del circuito',
  plan_flush_hint: 'Barridos deliberados del circuito durante el ascenso, del más profundo al más somero. Durante un barrido el circuito respira la mezcla elegida a presión ambiente, no el setpoint.',
  plan_flush_add: 'Añadir un barrido',
  plan_flush_none: 'Ningún barrido previsto',
  plan_flush_depth: 'Profundidad',
  plan_flush_gas: 'Barrer con',
  plan_flush_time: 'Duración',
  plan_flush_keep: 'Conservar esta mezcla',
  plan_flush_keep_hint: 'El circuito sigue con la mezcla del barrido hasta la superficie, que es la purga deliberada del helio antes de la descompresión. Sin marcar, vuelve al diluyente en servicio: un barrido es un gesto, no un cambio de gas.',
  plan_flush_remove: 'Eliminar',
  plan_flush_figures: '{gas} a {depth} m: ppO2 {ppO2} bar, END {end} m, densidad {density} g/L',
  plan_o2_flush_row: 'Final con oxígeno: {time} min de barrido a {depth} m, el circuito sigue con oxígeno hasta la superficie.',
  plan_o2_flush_source: 'Definido en los ajustes CCR, no editable aquí.',
  plan_o2_flush_skipped_setting: 'El final con oxígeno de los ajustes tiene una profundidad o una duración inutilizable y no se aplica.',
  plan_o2_flush_skipped_clash: 'El final con oxígeno de los ajustes se aparta a {depth} m: ya hay allí un barrido suyo planificado.',
  plan_o2_flush_skipped_too_deep: 'El final con oxígeno previsto a {depth} m no se aplica: esta inmersión nunca baja de {maxDepth} m.',
  plan_flush_helper: 'Calcular',
  plan_flush_helper_title: 'Profundidad del barrido',
  plan_flush_helper_hint: 'Indique lo que busca y se calcula la profundidad que lo da, para la mezcla de este barrido y para el agua y la altitud del sitio.',
  plan_flush_helper_mix: 'Mezcla del barrido',
  plan_flush_helper_target: 'Buscar',
  plan_flush_target_ppo2: 'ppO2 (bar)',
  plan_flush_target_end: 'END (m)',
  plan_flush_helper_result: '{depth} m ({exact} m exactamente)',
  plan_flush_helper_rounding: 'Redondeado al metro menos profundo, así que los valores de abajo son los que tendrá el plan.',
  plan_flush_helper_apply: 'Usar esta profundidad',
  plan_flush_helper_unreachable: 'Ninguna profundidad da eso con esta mezcla.',
  plan_flush_helper_deeper: 'Más profundo que el fondo a {maxDepth} m: un barrido se hace en el ascenso.',
  plan_flush_helper_no_nitrogen: 'Esta mezcla no lleva nitrógeno: su END es cero a cualquier profundidad.',
  plan_flush_helper_band: 'Fuera de su banda de trabajo {min} - {max} bar.',
  plan_descent: 'Descenso',
  plan_ascent: 'Ascenso',
  plan_bottom: 'Fondo',
  plan_stop: 'Parada',
  plan_total_runtime: 'Runtime total',
  plan_deco_time: 'Tiempo deco',
  plan_max_depth: 'Prof. max',
  plan_bottom_time: 'Tiempo fondo',
  plan_based_on_rmv: 'Basado en RMV',
  plan_insufficient_gas: 'Una o más botellas no tienen suficiente capacidad para este bailout!',
  plan_bars_needed: 'bares necesarios',

  // Profile
  profile_title: 'Perfil de buceo',
  profile_saturation: 'Saturación tisular',
  profile_tap_details: 'Tocar para detalles',
  profile_ceiling: 'Techo',
  profile_surface: 'Superficie',
  profile_residual: 'N2 residual',
  profile_calculate_hint: 'Calcula un plan para ver el perfil',
  profile_fullscreen: 'Pantalla completa',


  // Units
  unit_meters: 'm',
  unit_feet: 'ft',
  unit_minutes: 'min',
  unit_bar: 'bar',
  unit_psi: 'psi',
  unit_lpm: 'L/min',

  // Additional Plan
  plan_add_segment: 'Añadir segmento',
  plan_edit_segment: 'Editar segmento',
  plan_diluent: 'Diluyente',
  plan_dynamic_setpoint_info: 'Modo dinámico activo',
  plan_override_setpoint: 'Forzar un setpoint fijo (opcional)',
  plan_setpoint_auto: 'Auto',
  plan_mode: 'Modo',
  plan_algorithm: 'Algoritmo',
  plan_export_pdf: 'Exportar PDF',
  plan_save_html: 'Guardar HTML',
  plan_calculate_first: 'Calcula primero un plan',
  plan_segment_for: '{depth}m durante {time} min',
  plan_gas_at_sp: '{gas} @ SP{sp}',
  plan_tank: 'Botella',
  plan_needed: 'Necesario',
  plan_status: 'Estado',
  plan_insufficient: 'INSUFICIENTE',
  plan_gas_tight: 'JUSTO',
  plan_ok: 'OK',
  plan_need_more: 'Faltan {liters}L ({bars} bar)',
  plan_left: '{liters}L restantes ({bars} bar)',
  plan_need_more_liters: 'Faltan {liters}L',
  plan_left_liters: '{liters}L restantes',
  plan_gas_unused: 'NO RESPIRADO',
  plan_gas_unused_detail: '{liters}L transportados, nunca abiertos por este plan',
  plan_gas_backup: 'Refuerzo: {names}',

  // Gases additional
  gases_name_auto: 'Nombre (auto si vacío)',
  gases_auto_label: 'Etiqueta automática',
  gases_n2_calc: 'N2 % (calculado)',
  gases_end_at_mod: 'END @ MOD',
  gases_confirm_delete: 'Eliminar este gas?',
  gases_confirm_delete_diluent: 'Eliminar este diluyente?',
  gases_only_diluent: 'No se puede eliminar el único diluyente',
  gases_form_invalid: 'Valores no utilizables: O2 por encima de 0 % y como máximo 100 %, He de 0 % a menos de 100 %, su suma como máximo 100 %; límite de ppO2, volumen y presión de la botella por encima de 0.',
  plan_segment_invalid: 'Introduzca una profundidad de 1 a 200 m, una duración de 1 a 999 min y un setpoint de 0,7 a 1,6 bar.',

  // Segment types
  segment_bail: 'BAIL',
  segment_desc: 'Desc',
  segment_asc: 'Asc',
  segment_bottom: 'Fondo',
  segment_stop: 'Parada',
  segment_gas_change: 'Camb. gas',
  segment_diluent_change: 'Camb. dil.',
  segment_flush: 'Barrido',
  segment_safety_stop: 'Segur.',

  // Saved Plans
  nav_saved: 'Guardados',
  saved_plans_title: 'Planes guardados',
  saved_plans_save: 'Guardar plan',
  saved_plans_saved: 'Plan guardado!',
  saved_plans_empty: 'Sin planes guardados',
  saved_plans_empty_hint: 'Calcula un plan y guárdalo para después',
  saved_plans_load: 'Cargar',
  saved_plans_rename: 'Renombrar',
  saved_plans_duplicate: 'Duplicar',
  saved_plans_export: 'Exportar',
  saved_plans_confirm_delete: 'Eliminar este plan?',
  saved_plans_import: 'Importar',
  saved_plans_import_error: 'Error al importar',
  saved_plans_name_label: 'Nombre del plan',
  saved_plans_name_placeholder: 'Introduce el nombre',
  plan_share: 'Compartir',
  feature_next_version: 'Disponible en la próxima versión',

  // Dive environment carried by a plan: named in the exports and in the saved
  // plan list, and flagged when the plan on screen was computed for another one
  plan_environment_changed: 'Este plan se calculó para otro tipo de agua u otra altitud. Vuelva a calcularlo antes de sumergirse.',
  // Any other input the calculation reads (gradient factors, rates, ppO2
  // limits, gases, rebreather...) changed after the plan was computed
  plan_inputs_changed: 'Este plan se calculó con otros parámetros de buceo. Vuelva a calcularlo antes de sumergirse.',
  export_environment: 'Entorno',
  saved_plan_environment: 'Entorno',

  // PDF Export
  pdf_title: 'Plan de buceo - mvplan',
  pdf_exporting: 'Generando PDF...',
  pdf_generated: 'Generado',
  pdf_mode_oc: 'Circuito abierto',
  pdf_footer_generated: 'Generado por mvplan - Planificador de buceo técnico',
  pdf_footer_verify: 'Verifique siempre su plan y lleve tablas de respaldo',

  // PDF format choice
  pdf_choose_format: 'Formato del PDF',
  pdf_choose_format_hint: 'Elija qué documento exportar',
  pdf_format_complete: 'Completo',
  pdf_format_complete_hint: 'Informe detallado de varias páginas (tablas, perfil, gas)',
  pdf_format_condensed: 'Condensado (1 página)',
  pdf_format_condensed_hint: 'Hoja de planificación imprimible en una sola página',

  // PDF condensed form
  pdf_form_title: 'Planificación de buceo',
  pdf_form_date: 'Fecha',
  pdf_form_team: 'Equipo n.º',
  pdf_form_diver: 'Buceador',
  pdf_form_lastname: 'Nombre, Apellido',
  pdf_form_machine: 'Equipo',
  pdf_form_gf: 'Grad. Fac.',
  pdf_form_runtime_title: 'Run Time',
  pdf_form_planned_depth: 'Profundidad prevista',
  pdf_form_planned_bottom: 'Tiempo de fondo previsto',
  pdf_form_palier: 'Prof. parada',
  pdf_form_descent: 'Descenso',
  pdf_form_bottom: 'Fondo',
  pdf_form_duration: 'Duración',
  pdf_form_cumul: 'Acum.',
  pdf_form_mutualized: 'Compartido',
  pdf_form_vol_liters: '% / Vol. en litros',
  pdf_form_col_pct: '%',
  pdf_form_col_vol: 'Vol.',
  pdf_form_col_press: 'Pres.',
  pdf_form_col_liters: 'Lit.',
  pdf_form_yes: 'sí',
  pdf_form_no: 'no',
  pdf_form_gas_switch_legend: 'cambio de gas',
  pdf_form_gas_verdict_legend: "Casilla Lit. del buceador 1: verde = OK, naranja = justo, rojo = insuficiente para el ascenso con bailout, gris = no respirado. Cifras en la columna de la derecha.",
  pdf_form_dtr: 'TTS',

  // Safety Alerts
  alerts_summary_title: 'Puntos de atención de este plan',
  alert_hypoxia: 'ppO2 {value} bar por debajo del mínimo de 0.16 bar: esta mezcla no es respirable a esta profundidad. Prevea un gas más rico en oxígeno.',
  alert_hyperoxia: 'ppO2 {value} bar por encima del máximo de 1.6 bar. Reduzca la fracción de oxígeno o use este gas a menor profundidad.',
  alert_end_critical: 'END {value}m más allá del límite de 40m. Añada helio a la mezcla de fondo para reducir la narcosis.',
  alert_end_high: 'END {value}m por encima de los 30m recomendados. Una mezcla más rica en helio reduce la narcosis.',
  alert_density_critical: 'Densidad del gas {value} g/L por encima de los 6.2 g/L recomendados: la respiración puede volverse difícil a esta profundidad. Añada helio a la mezcla de fondo.',
  alert_density_high: 'Densidad del gas {value} g/L por encima de los 5.2 g/L aconsejados en recirculador. Limite el esfuerzo o enriquezca el diluyente con helio.',
  alert_narcosis_increase: 'La ppN2 pasa de {ccrValue} a {value} bar al pasar al bailout: más narcosis que en el recirculador. Un bailout más rico en helio suaviza la transición.',
  alert_end_increase: 'La END pasa de {ccrValue}m a {value}m al pasar al bailout. Un bailout más rico en helio reduce esta diferencia.',
  alert_icd_risk: 'El helio cae de {prevValue}% a {value}% en este cambio de gas. Una transición más gradual (mezcla intermedia) evita la contradifusión isobárica.',
  alert_ceiling_violation: 'Este perfil asciende a {depth}m cuando el techo de deco está a {ceiling}m. Manténgase por debajo del techo y prolongue la parada antes de ascender.',
  alert_stop_time_truncated: 'Parada a {depth}m limitada a {time} min: se alcanzó el límite interno de cálculo sin liberar el techo. Este plan está incompleto, no lo siga - reduzca el tiempo de fondo, añada un gas deco o suba el GF alto.',
  alert_runtime_limit: 'Cálculo interrumpido en el límite interno de runtime de {runtime} min: este plan está incompleto, no lo siga - acorte la inmersión o añada un gas deco más rico.',
  alert_entry_ceiling: 'Techo de {ceiling}m al inicio de esta inmersión, con los factores de gradiente definidos aquí: el intervalo de superficie de {interval} min no libera la inmersión anterior, el buceador ya debe una parada antes de volver al agua. Este plan lo compensa durante el ascenso: alargue el intervalo antes de bucearlo.',
  alert_residual_state_unloaded: 'Estado tisular residual sin ninguna carga: dice seguir a una inmersión y sin embargo ningún compartimento está por encima de su nivel de reposo. Este plan es por tanto más corto que la misma inmersión calculada con tejidos limpios: no lo bucee, vuelva a calcular la inmersión anterior.',
  alert_default_gas_fallback: 'Ninguna mezcla activa: este plan se ha calculado con aire por defecto. No corresponde a los gases que ha configurado - active al menos una mezcla en la vista Gases y vuelva a calcular antes de sumergirse.',
  alert_gas_above_mod: 'Ningún gas transportado alcanza {depth}m bajo el límite de ppO2 de {limit} bar que se aplica allí: este plan hace respirar {gas} a esa profundidad, más allá de su MOD de {mod}m con ese límite, con una ppO2 de {ppO2} bar. Es la mezcla más pobre de su lista, elegida por defecto y no por usted - lleve una mezcla adecuada a esa profundidad, o suba el límite, antes de sumergirse.',
  alert_gas_switch_on_empty: 'La botella de {gas} se vacía a {depth}m: el cambio de gas que aparece ahí no es una conmutación de descompresión prevista por usted, es el plan pasando a lo que queda. Lleve más de esa mezcla, o planifique su propio cambio por encima de esa profundidad, antes de bucear.',
  alert_gas_exhausted: 'Todas las botellas utilizables a {depth}m están vacías: a partir de ahí este plan prescribe gas que ya no lleva. Añada capacidad, o una mezcla que alcance esa profundidad, antes de bucear.',
  alert_gas_insufficient: 'Las botellas de {gas} contienen {capacity} L y este plan respira {liters} L de esa mezcla: faltan {missing} L. Lleve más cantidad o planifique una inmersión más corta antes de bucear.',
  alert_flush_not_reached: 'El barrido del circuito previsto a {depth}m nunca ocurre: el ascenso final empieza a {ascentStart}m, por encima. Suba el barrido o hágalo el último nivel de la inmersión.',
  alert_flush_ppo2: 'El barrido de {depth}m con {gas} deja el circuito a {ppO2} bar de oxígeno, fuera de su banda de trabajo {min} - {max} bar. Durante un barrido el setpoint no se mantiene: el circuito vale lo que la mezcla da a esa profundidad.',
  alert_o2_flush_too_deep: 'El final con oxígeno previsto a {depth}m no ocurre nunca: esta inmersión nunca baja de {maxDepth}m, ningún ascenso pasa por esa profundidad.',

  // Plan validation errors
  plan_error_title: 'No se puede calcular el plan',
  plan_error_no_segments: 'Ningún segmento de inmersión: añada al menos un segmento con profundidad y tiempo.',
  plan_error_invalid_depth: 'Profundidad no válida: introduzca una profundidad mayor o igual que 0 m en cada segmento (0 m es un intervalo de superficie).',
  plan_error_invalid_time: 'Tiempo no válido: introduzca una duración mayor o igual que 0 min en cada segmento.',
  plan_error_invalid_gf: 'Factores de gradiente no válidos: el GF bajo debe ser menor o igual que el GF alto, y ambos mayores que 0% y como máximo 100%.',
  plan_error_invalid_gas: 'Mezcla de gas no válida: la fracción de O2 debe ser mayor que 0% y como máximo 100%, la fracción de He entre 0% y menos de 100%, y su suma no debe superar el 100%.',
  plan_error_no_diluent: 'Ningún diluyente válido: elija un diluyente para la inmersión con rebreather en la vista Gases.',
  plan_error_invalid_setpoint: 'Setpoint no válido: introduzca un setpoint de ppO2 entre 0.4 y 1.6 bar, límites incluidos.',
  plan_error_no_bailout_gas: 'Ningún gas de rescate activo: active al menos un gas bailout en la vista Gases para calcular el bailout.',
  plan_error_invalid_tissue_state: 'Estado tisular residual inutilizable: no se ha podido leer la inmersión anterior de la serie. Vuelva a calcular la inmersión anterior antes de planificar esta.',
  plan_error_invalid_surface_interval: 'Intervalo de superficie no válido: introduzca una duración igual o superior a 0 min entre la inmersión anterior y esta.',
  plan_error_invalid_flush: 'Barrido de circuito no válido: asigne a cada barrido una profundidad por encima del fondo, una duración mayor que 0 min y un solo barrido por profundidad.',
  plan_error_time_shorter_than_descent: 'Duración del segmento menor que su descenso: llegar a {depth} m lleva {descentTime} min a la velocidad de descenso configurada, y el segmento solo dura {time} min. El tiempo de descenso está incluido en la duración del segmento (ver ajustes): introduzca una duración mayor o desactive esa opción.',
  plan_error_segment_gas_unavailable: 'El segmento {index} ({depth} m) está planificado con {gas}, que está desactivado o ya no existe. Active ese gas en la vista Gases o elija otro para el segmento.',
  plan_error_no_bailout_point: 'El plan de recirculador no lleva punto de bailout: no fue producido por esta versión del planificador. Vuelva a calcular el plan de recirculador antes de su bailout.',
  plan_error_invalid_config: 'Ajuste del planificador no válido: una velocidad de ascenso o descenso, una profundidad de parada o un límite de ppO2 está fuera de rango. Revise los ajustes del planificador antes de calcular.',

  // Dive Info
  plan_notes: 'Notas',
  plan_notes_placeholder: 'Añadir notas para el plan impreso (recordatorios, instrucciones, etc.)',
  plan_divers_placeholder: 'Buceadores para esta inmersión',

  // App Store Links
  app_available_on: 'Disponible en:',
  app_get_ios: 'Descargar en App Store',
  app_get_android: 'Descargar en Google Play',

  // Tissue compartment descriptions
  tissue_desc_1: 'Sangre, médula espinal',
  tissue_desc_2: 'Sangre, cerebro',
  tissue_desc_3: 'Cerebro, tejido nervioso',
  tissue_desc_4: 'Músculos bien irrigados',
  tissue_desc_5: 'Piel, vísceras',
  tissue_desc_6: 'Músculos, órganos',
  tissue_desc_7: 'Músculos',
  tissue_desc_8: 'Músculos, ligamentos',
  tissue_desc_9: 'Tendones, tejido conectivo',
  tissue_desc_10: 'Cartílagos',
  tissue_desc_11: 'Cartílagos, huesos',
  tissue_desc_12: 'Huesos, articulaciones',
  tissue_desc_13: 'Huesos, grasa',
  tissue_desc_14: 'Tejido adiposo',
  tissue_desc_15: 'Grasa, médula ósea',
  tissue_desc_16: 'Grasa, médula ósea',
  tissue_halftime: 'Semivida',
  tissue_speed_fast: 'tejido rápido',
  tissue_speed_medium: 'tejido medio',
  tissue_speed_slow: 'tejido lento',
  tissue_leading: 'Compartimento director',
  tissue_leading_detail: '{tissue} (C{num}) impone su techo a {ceiling}m - cargado al {gf}% (GF {gfLow}/{gfHigh}, límite aquí: {gfLimit}%)',
  tissue_leading_no_ceiling: '{tissue} (C{num}) es el más cargado - cargado al {gf}% (GF {gfLow}/{gfHigh}, límite aquí: {gfLimit}%)',
  tissue_detail_title: 'Detalle del compartimento',
  tissue_detail_coefficients: 'Coeficientes {algo}: a={a} (tolerancia a la sobresaturación), b={b} (sensibilidad a la profundidad). Constantes empíricas de Bühlmann - los tejidos rápidos (C1) toleran más (a=1.17), los tejidos lentos (C16) menos (a=0.23).',
  tissue_detail_saturation: 'Saturación',
  tissue_detail_gf_actual: 'GF real',
  tissue_detail_no_supersaturation: 'Sin sobresaturación',
  tissue_detail_undersaturated: 'Este compartimento no está sobresaturado: la presión tisular es inferior a la presión ambiente. El concepto de GF solo se aplica cuando el tejido está sobresaturado (en ascenso o en una parada).',
  tissue_detail_explanation: '{saturation}% de saturación no significa {saturation}% de GF. El GF ({gfActual}%) mide la fracción de margen utilizada entre la presión ambiente y la M-value. Con GF High {gfHigh}%, una saturación de {saturation}% es esperada.',
  tissue_detail_explanation_gf_low: 'GF Low ({gfLow}%) determina la profundidad de la primera parada de descompresión. Aquí el algoritmo permite al buceador detenerse por primera vez en el ascenso: el compartimento director utiliza {gfUsed}% de su margen entre presión ambiente y M-value. Cuanto menor sea el GF Low, más profundas comienzan las paradas.',
  tissue_detail_explanation_interpolated: 'Entre la primera parada y la superficie, el GF se interpola linealmente de GF Low ({gfLow}%) a GF High ({gfHigh}%). A esta profundidad, el límite aplicado es {gfUsed}%. El GF real de este compartimento es {gfActual}%.',

  // Disclaimer
  disclaimer_title: 'Aviso legal',
  disclaimer_text: 'Este software es solo una ayuda para la planificación de buceo. No sustituye la formación, la experiencia ni el criterio del buceador. Los autores no aceptan responsabilidad por accidentes o incidentes. Verifique siempre su plan con otras herramientas y lleve tablas de respaldo.',
  disclaimer_short: 'Solo ayuda de planificación - no sustituye formación ni criterio - sin responsabilidad',

  // Apoyar el proyecto
  support_nav: 'Apoyar el proyecto',
  support_nav_website: 'El proyecto',
  support_title: 'Apoyar MV-Plan',
  support_intro: 'MV-Plan es software libre. Sin publicidad, sin cuenta que crear, sin recogida de datos, y todas las funciones están al alcance de todos. Eso no va a cambiar.',
  support_costs_title: 'Lo que cuesta el proyecto',
  support_cost_apple: 'Cuenta de desarrollador de Apple: 99 USD al año, aunque la aplicación sea gratuita.',
  support_cost_google: 'Cuenta de desarrollador de Google Play: 25 USD una sola vez.',
  support_cost_domain: 'Nombre de dominio y alojamiento del sitio mvplan.org.',
  support_cost_time: 'El tiempo dedicado a desarrollar, probar y documentar el planificador.',
  support_amount: 'Con unos pocos euros basta. La mayoría de las aportaciones van de 3 a 10 euros, y ya ayudan mucho.',
  support_nothing_unlocked: 'Aportar no desbloquea nada: no hay versión de pago, ni opción oculta, ni nombres en una lista. La aplicación sigue siendo la misma para todos.',
  support_thanks: 'Gracias a quienes ya han aportado.',
  support_button: 'Aportar',
  support_link_label: 'Dirección de la página',
  support_copy: 'Copiar el enlace',
  support_copied: 'Enlace copiado',
  support_copy_failed: 'No se ha podido copiar, seleccione la dirección a mano',
  support_open_hint: 'Si el botón no abre nada, copie la dirección de arriba en su navegador.',
  support_website_title: 'El proyecto',
  support_website_intro: 'MV-Plan es software libre, desarrollado en el tiempo libre de su autor. El sitio del proyecto reúne la documentación, las notas de versión y las formas de contacto.',
  support_website_button: 'Abrir el sitio del proyecto'
}
